import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, inject } from '@angular/core'

import { ApiPreofferService } from '@data/services/modules/preoffer/api-preoffer.service'
import { PreofferMode } from '@data/interfaces/preoffer.interface'

export const MODE_NOTICES: Readonly<Record<PreofferMode | 'unknown', { tone: 'info' | 'neutral' | 'warn'; icon: string; text: string }>> = {
  off: { tone: 'neutral', icon: 'fa-solid fa-power-off', text: 'No cambia el Comité. La preoferta está apagada: este puntaje no le da preoferta a nadie.' },
  shadow: {
    tone: 'info',
    icon: 'fa-solid fa-eye',
    text: 'No cambia el Comité. Con el puntaje mínimo y los requisitos, la calculadora del cliente nuevo le daría una preoferta; está en sombra: solo se ve aquí, no se envía.',
  },
  live: {
    tone: 'warn',
    icon: 'fa-solid fa-envelope-circle-check',
    text: 'No cambia el Comité. La preoferta está encendida: con el puntaje mínimo y los requisitos, el cliente nuevo la recibe por correo.',
  },
  unknown: { tone: 'neutral', icon: 'fa-solid fa-circle-info', text: 'No cambia el Comité. Con el puntaje mínimo y los requisitos, alimenta la preoferta del cliente nuevo.' },
}

/**
 * Plan v4.3 §9.1 · Franja de la calculadora según el modo de la preoferta (apagada · sombra · encendida). Mientras carga
 * o si falla, dice lo que vale en cualquier modo; nunca afirma un modo que no leyó.
 */
@Component({
  selector: 'app-preoffer-mode-notice',
  template: `<p class="alg-notice" [ngClass]="'is-' + notice.tone" [attr.data-mode]="mode ?? 'unknown'">
    <i [class]="notice.icon" aria-hidden="true"></i>
    <span>{{ notice.text }}</span>
  </p>`,
  styleUrls: ['./preoffer-mode-notice.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreofferModeNoticeComponent implements OnInit {
  mode: PreofferMode | null = null

  private readonly api = inject(ApiPreofferService)
  private readonly cd = inject(ChangeDetectorRef)

  get notice() {
    return MODE_NOTICES[this.mode ?? 'unknown']
  }

  ngOnInit(): void {
    this.api.mode().subscribe((response) => {
      this.mode = response.error ? null : (response.data?.mode ?? null)
      this.cd.markForCheck()
    })
  }
}
